document.querySelectorAll('.slider-section').forEach(section => {
    const inner = section.querySelector('.slider-section-inner');
    const slider = inner.querySelector('.slider-section-slides');
    const slides = slider.querySelectorAll('.slider-section-slide');
    const nav = document.createElement('nav');
    nav.classList.add('slider-section-nav');
    inner.appendChild(nav);

    // const enlargeButton = document.createElement('button');
    // enlargeButton.classList.add('slider-section-enlarge');
    // enlargeButton.innerHTML = '<i class="fas fa-arrow-up-right-and-arrow-down-left-from-center"></i>';
    // // enlargeButton.addEventListener('click', e => {
    // inner.addEventListener('click', e => {
    //     e.preventDefault();
    //     if(e.target.closest('.slider-section-nav')) return;

    //     if(document.fullscreenElement) {
    //         document.exitFullscreen();
    //         return;
    //     }
    //     inner.requestFullscreen();
    // });
    // nav.appendChild(enlargeButton);

    if(slides.length <= 1) return;

    const prevButton = document.createElement('button');
    prevButton.classList.add('slider-section-prev');
    prevButton.innerHTML = '<i class="fas fa-chevron-left"></i>';
    prevButton.addEventListener('click', e => {
        e.preventDefault();
        slider.scrollBy({
            left: -slider.offsetWidth,
            behavior: 'smooth'
        });
    });
    nav.appendChild(prevButton);

    const nextButton = document.createElement('button');
    nextButton.classList.add('slider-section-next');
    nextButton.innerHTML = '<i class="fas fa-chevron-right"></i>';
    nextButton.addEventListener('click', e => {
        e.preventDefault();
        slider.scrollBy({
            left: slider.offsetWidth,
            behavior: 'smooth'
        });
    });
    nav.appendChild(nextButton);

    const update = () => {
        const slide = Array.from(slides).find(slide => {
            const rect = slide.getBoundingClientRect();
            const sliderRect = slider.getBoundingClientRect();
            return rect.left >= sliderRect.left - 100 && rect.right <= sliderRect.right + 100;
        });
        if(!slide) return;

        prevButton.classList.toggle('slider-section-button-disabled', !slide.previousElementSibling);
        nextButton.classList.toggle('slider-section-button-disabled', !slide.nextElementSibling);
    };

    slider.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    update();
});